/**
 * @generated SignedSource<<d0a03c082068780a06156d925c6b2941>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoutineOccasionStatus = "COMPLETED" | "FUTURE" | "IN_PROGRESS" | "IN_PROGRESS_EXPIRED" | "NOT_COMPLETED" | "NOT_COMPLETED_STARTED" | "NO_TASKS_COMPLETED" | "REQUIRED_COMPLETED";
export type RoutineOccasionScreenReloadStatusQuery$variables = {
  routineId: string;
  sequenceNumber: number;
  storeId?: string | null;
};
export type RoutineOccasionScreenReloadStatusQuery$data = {
  readonly routine: {
    readonly occasion: {
      readonly id: string;
      readonly status: RoutineOccasionStatus;
    } | null;
  } | null;
};
export type RoutineOccasionScreenReloadStatusQuery = {
  response: RoutineOccasionScreenReloadStatusQuery$data;
  variables: RoutineOccasionScreenReloadStatusQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sequenceNumber"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "sequenceNumber",
      "variableName": "sequenceNumber"
    },
    {
      "kind": "Variable",
      "name": "storeId",
      "variableName": "storeId"
    }
  ],
  "concreteType": "RoutineOccasion",
  "kind": "LinkedField",
  "name": "occasion",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoutineOccasionScreenReloadStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoutineOccasionScreenReloadStatusQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c6d4fb34d834bb2f277cf953939792fd",
    "id": null,
    "metadata": {},
    "name": "RoutineOccasionScreenReloadStatusQuery",
    "operationKind": "query",
    "text": "query RoutineOccasionScreenReloadStatusQuery(\n  $routineId: ID!\n  $sequenceNumber: Int!\n  $storeId: ID\n) {\n  routine(id: $routineId) {\n    occasion(sequenceNumber: $sequenceNumber, storeId: $storeId) {\n      id\n      status\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c730c8587b1469be91fdae6da4830d4e";

export default node;
